module.exports = __webpack_public_path__ + "static/media/orange-square.93cf5d51.svg";